import { buildBaseContactParameters } from '../buildCommonContactParameters'
import type { ContactSubscriptionData } from '../contactSubscriptionData'

type Parameters = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
  doorToDoorPartnerChecklistCheckedTitles: Record<string, boolean>
  doorToDoorPartnerLeadSource: string
}

export const contactSaveParametersGeneration = (parameters: Parameters): URLSearchParams => {
  const options = buildBaseContactParameters(parameters)

  const {
    personal: { mcpAdvisoryId },
    professional: { siret, activity, apeCode, taxId },
  } = parameters.contactData

  const resolvedMcpAdvisoryId = mcpAdvisoryId ?? null
  if (resolvedMcpAdvisoryId !== null && String(resolvedMcpAdvisoryId).length > 0) {
    options.append('mcp_advisory_id', String(resolvedMcpAdvisoryId))
  }

  options.append('pro_siret', siret || '')
  options.append('pro_activity', activity || '')
  options.append('pro_ape_code', apeCode || '')
  options.append('pro_tax_id', taxId || '')

  return options
}
